import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { processAnimations, processAnimationsMobile } from './process-graphic'
import { statsGridAnimations } from './stats-grid'

gsap.registerPlugin(ScrollTrigger)

export function initFrontPageAnimations() {
  heroContentAnimations()
  statsGridAnimations()

  if (window.matchMedia('(min-width: 1024px)').matches) {
    processAnimations()
  } else {
    processAnimationsMobile()
  }
}

// =============================================================================
// Hero Content Animations
// =============================================================================
function heroContentAnimations() {
  const heroContent = document.querySelector('.hero__content')
  if (!heroContent) return

  const contentBlock = heroContent.querySelector('.content-block')
  const title = heroContent.querySelector('.hero__title')
  const description = heroContent.querySelector('p')
  const button = heroContent.querySelector('.hero__button')

  // Create main timeline for hero content - play immediately
  const heroContentTL = gsap.timeline()

  // Content block
  if (contentBlock) {
    heroContentTL.to(contentBlock, {
      opacity: 1,
      y: 0,
      duration: 0.8,
      ease: 'power2.out'
    }, 0.6)
  }

  // Images - Background elements first, then main image
  const bgCircles = heroContent.querySelector('.hero__image-bg-circles')
  const heroImage = heroContent.querySelector('.hero__image-svg')

  // Background circles
  if (bgCircles) {
    heroContentTL.to(bgCircles, {
      opacity: 0.3,
      duration: 1,
      ease: 'power2.out'
    }, 0.8)
  }

  // Hero image
  if (heroImage) {
    heroContentTL.to(heroImage, {
      opacity: 1,
      marginTop: 0,
      duration: 1,
      ease: 'power2.out'
    }, 0.8)
  }
}
